/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 */
export const CLS_RTE = 'e-richtexteditor';
/**
 * @hidden
 */
export const CLS_RTL = 'e-rtl';
/**
 * @hidden
 */
export const CLS_CONTENT = 'e-content';
/**
 * @hidden
 */
export const CLS_DISABLED = 'e-disabled';
/**
 * @hidden
 */
export const CLS_SCRIPT_SHEET = 'rte-iframe-script-sheet';
/**
 * @hidden
 */
export const CLS_STYLE_SHEET = 'rte-iframe-style-sheet';
/**
 * @hidden
 */
export const CLS_RTE_CONTAINER = 'e-rte-container';
/**
 * @hidden
 */
export const CLS_RTE_IFRAME_CONTENT = 'e-rte-iframe-content';
/**
 * @hidden
 */
export const CLS_TOOLBAR = 'e-rte-toolbar';
/**
 * @hidden
 */
export const CLS_TB_FIXED = 'e-rte-tb-fixed';
/**
 * @hidden
 */
export const CLS_TB_FLOAT = 'e-rte-tb-float';
/**
 * @hidden
 */
export const CLS_INLINE = 'e-rte-inline';
/**
 * @hidden
 */
export const CLS_TB_INLINE = 'e-rte-tb-inline';
/**
 * @hidden
 */
export const CLS_RTE_EXPAND_TB = 'e-rte-tb-expand';
/**
 * @hidden
 */
export const CLS_FULL_SCREEN = 'e-rte-full-screen';
/**
 * @hidden
 */
export const CLS_QUICK_TB = 'e-rte-quick-toolbar';
/**
 * @hidden
 */
export const CLS_TEXT_QUICK_TB = 'e-text-quicktoolbar';
/**
 * @hidden
 */
export const CLS_IMG_QUICK_TB = 'e-image-quicktoolbar';
/**
 * @hidden
 */
export const CLS_AUDIO_QUICK_TB = 'e-audio-quicktoolbar';
/**
 * @hidden
 */
export const CLS_VIDEO_QUICK_TB = 'e-video-quicktoolbar';
/**
 * @hidden
 */
export const CLS_TABLE_QUICK_TB = 'e-table-quicktoolbar';
/**
 * @hidden
 */
export const CLS_LINK_QUICK_TB = 'e-link-quicktoolbar';
/**
 * @hidden
 */
export const CLS_TB_STATIC = 'e-tb-static';
/**
 * @hidden
 */
export const CLS_QUICK_POP = 'e-rte-quick-popup';
/**
 * @hidden
 */
export const CLS_INLINE_POP = 'e-rte-inline-popup';
/**
 * @hidden
 */
export const CLS_QUICK_TBAR_TIP_POINTER = 'e-rte-tip-pointer';
/**
 * @hidden
 */
export const CLS_QUICK_DROPDOWN = 'e-quick-dropdown';
/**
 * @hidden
 */
export const CLS_INLINE_TOOLBAR = 'e-rte-inline-toolbar';
/**
 * @hidden
 */
export const CLS_INLINE_DROPDOWN = 'e-rte-inline-dropdown';
/**
 * @hidden
 */
export const CLS_DROPDOWN_POPUP = 'e-rte-dropdown-popup';
/**
 * @hidden
 */
export const CLS_DROPDOWN_ICONS = 'e-rte-dropdown-icons';
/**
 * @hidden
 */
export const CLS_DROPDOWN_ITEMS = 'e-rte-dropdown-items';
/**
 * @hidden
 */
export const CLS_DROPDOWN_BTN = 'e-rte-dropdown-btn';
/**
 * @hidden
 */
export const CLS_RTE_CONTENT = 'e-rte-content';
/**
 * @hidden
 */
export const CLS_TB_ITEM = 'e-toolbar-item';
/**
 * @hidden
 */
export const CLS_TB_EXTENDED = 'e-toolbar-extended';
/**
 * @hidden
 */
export const CLS_TB_WRAP = 'e-toolbar-wrapper';
/**
 * @hidden
 */
export const CLS_POPUP = 'e-popup';
/**
 * @hidden
 */
export const CLS_SEPARATOR = 'e-separator';
/**
 * @hidden
 */
export const CLS_MINIMIZE = 'e-minimize';
/**
 * @hidden
 */
export const CLS_MAXIMIZE = 'e-maximize';
/**
 * @hidden
 */
export const CLS_BACK = 'e-back';
/**
 * @hidden
 */
export const CLS_SHOW = 'e-show';
/**
 * @hidden
 */
export const CLS_HIDE = 'e-hide';
/**
 * @hidden
 */
export const CLS_VISIBLE = 'e-visible';
/**
 * @hidden
 */
export const CLS_FOCUS = 'e-focused';
/**
 * @hidden
 */
export const CLS_RM_WHITE_SPACE = 'e-remove-white-space';
/**
 * @hidden
 */
export const CLS_IMG_CAPTION_CONTAINER = 'e-img-caption-container';
/**
 * @hidden
 */
export const CLS_IMG_RIGHT = 'e-img-right';
/**
 * @hidden
 */
export const CLS_IMG_LEFT = 'e-img-left';
/**
 * @hidden
 */
export const CLS_IMG_CENTER = 'e-img-center';
/**
 * @hidden
 */
export const CLS_IMAGE_LEFT_WRAP = 'e-img-left-wrap';
/**
 * @hidden
 */
export const CLS_IMAGE_RIGHT_WRAP = 'e-img-right-wrap';
/**
 * @hidden
 */
export const CLS_IMG_INLINE = 'e-img-inline';
/**
 * @hidden
 */
export const CLS_IMG_BREAK = 'e-img-break';
/**
 * @hidden
 */
export const CLS_AUDIOBREAK = 'e-audio-break';
/**
 * @hidden
 */
export const CLS_CLICKELEM = 'e-clickelem';
/**
 * @hidden
 */
export const CLS_VID_CLICK_ELEM = 'e-video-clickelem';
/**
 * @hidden
 */
export const CLS_AUDIOWRAP = 'e-audio-wrap';
/**
 * @hidden
 */
export const CLS_VIDEOWRAP = 'e-video-wrap';
/**
 * @hidden
 */
export const CLS_VIDEOBREAK = 'e-video-break';
/**
 * @hidden
 */
export const CLS_AUDIOINLINE = 'e-audio-inline';
/**
 * @hidden
 */
export const CLS_VIDEOINLINE = 'e-video-inline';
/**
 * @hidden
 */
export const CLS_COUNT = 'e-rte-character-count';
/**
 * @hidden
 */
export const CLS_WARNING = 'e-warning';
/**
 * @hidden
 */
export const CLS_ERROR = 'e-error';
/**
 * @hidden
 */
export const CLS_ICONS = 'e-icons';
/**
 * @hidden
 */
export const CLS_ACTIVE = 'e-active';
/**
 * @hidden
 */
export const CLS_EXPAND_OPEN = 'e-expand-open';
/**
 * @hidden
 */
export const CLS_RTE_ELEMENTS = 'e-rte-elements';
/**
 * @hidden
 */
export const CLS_TB_BTN = 'e-tbar-btn';
/**
 * @hidden
 */
export const CLS_EDIT_CELL_DROPDOWN = 'e-rte-edit-cell-dropdown';
/**
 * @hidden
 */
export const CLS_DROPDOWN_MENU = 'e-rte-dropdown-menu';
/**
 * @hidden
 */
export const CLS_HR_SEPARATOR = 'e-rte-horizontal-separator';
/**
 * @hidden
 */
export const CLS_TB_IOS_FIX = 'e-tbar-ios-fixed';
/**
 * @hidden
 */
export const CLS_LIST_PRIMARY_CONTENT = 'e-rte-list-primary-content';
/**
 * @hidden
 */
export const CLS_NUMBERFORMATLIST_TB_BTN = 'e-rte-numberformatlist-dropdown';
/**
 * @hidden
 */
export const CLS_BULLETFORMATLIST_TB_BTN = 'e-rte-bulletformatlist-dropdown';
/**
 * @hidden
 */
export const CLS_CODEBLOCK_TB_BTN = 'e-rte-codeblock-dropdown';
/**
 * @hidden
 */
export const CLS_CODEBLOCK_TB_BTN_ICON = 'e-rte-code-block-icon e-preformat-code';
/**
 * @hidden
 */
export const CLS_FORMATS_TB_BTN = 'e-formats-tbar-btn';
/**
 * @hidden
 */
export const CLS_FONT_NAME_TB_BTN = 'e-font-name-tbar-btn';
/**
 * @hidden
 */
export const CLS_FONT_SIZE_TB_BTN = 'e-font-size-tbar-btn';
/**
 * @hidden
 */
export const CLS_ALIGN_TB_BTN = 'e-alignment-tbar-btn';
/**
 * @hidden
 */
export const CLS_LINE_HEIGHT_TB_BTN = 'e-line-height-tbar-btn';
/**
 * @hidden
 */
export const CLS_BORDER_STYLE_BTN = 'e-border-style-btn';
/**
 * @hidden
 */
export const CLS_BORDERCOLOR_COLORPICKER = 'e-rte-border-colorpicker';
/**
 * @hidden
 */
export const CLS_TABLE_BGCOLOR_COLORPICKER = 'e-rte-table-bg-colorpicker';
/**
 * @hidden
 */
export const CLS_FONT_COLORPICKER = 'e-rte-font-colorpicker';
/**
 * @hidden
 */
export const CLS_BACKGROUND_COLORPICKER = 'e-rte-background-colorpicker';
/**
 * @hidden
 */
export const CLS_NUMBERFORMATLIST_DROPDOWN = 'e-rte-numberformatlist-dropdown';
/**
 * @hidden
 */
export const CLS_BULLETFORMATLIST_DROPDOWN = 'e-rte-bulletformatlist-dropdown';
/**
 * @hidden
 */
export const CLS_DROPDOWN = 'e-rte-dropdown';
/**
 * @hidden
 */
export const CLS_COLOR_PALETTE = 'e-rte-square-palette';
/**
 * @hidden
 */
export const CLS_RTE_READONLY = 'e-rte-readonly';
/**
 * @hidden
 */
export const CLS_RTE_HIDDEN = 'e-rte-hidden';
/**
 * @hidden
 */
export const CLS_RTE_PASTE_KEEP_FORMAT = 'e-rte-keepformat';
/**
 * @hidden
 */
export const CLS_RTE_PASTE_REMOVE_FORMAT = 'e-rte-removeformat';
/**
 * @hidden
 */
export const CLS_RTE_PASTE_PLAIN_FORMAT = 'e-rte-plainformat';
/**
 * @hidden
 */
export const CLS_RTE_PASTE_OK = 'e-rte-pasteok';
/**
 * @hidden
 */
export const CLS_RTE_PASTE_CANCEL = 'e-rte-pastecancel';
/**
 * @hidden
 */
export const CLS_RTE_DIALOG_MIN_HEIGHT = 'e-rte-dialog-minheight';
/**
 * @hidden
 */
export const CLS_RTE_RES_HANDLE = 'e-resize-handle';
/**
 * @hidden
 */
export const CLS_RTE_RES_EAST = 'e-south-east';
/**
 * @hidden
 */
export const CLS_RTE_IMAGE = 'e-rte-image';
/**
 * @hidden
 */
export const CLS_RTE_UPLOAD_POPUP = 'e-rte-upload-popup';
/**
 * @hidden
 */
export const CLS_POPUP_OPEN = 'e-popup-open';
/**
 * @hidden
 */
export const CLS_POPUP_CLOSE = 'e-popup-close';
/**
 * @hidden
 */
export const CLS_IMG_RESIZE = 'e-img-resize';
/**
 * @hidden
 */
export const CLS_VID_RESIZE = 'e-vid-resize';
/**
 * @hidden
 */
export const CLS_DROPAREA = 'e-droparea';
/**
 * @hidden
 */
export const CLS_IMG_INNER = 'e-img-inner';
/**
 * @hidden
 */
export const CLS_UPLOAD_FILES = 'e-upload-files';
/**
 * @hidden
 */
export const CLS_RTE_DIALOG_UPLOAD = 'e-rte-dialog-upload';
/**
 * @hidden
 */
export const CLS_RTE_RES_CNT = 'e-rte-resize';
/**
 * @hidden
 */
export const CLS_CUSTOM_TILE = 'e-custom-tile';
/**
 * @hidden
 */
export const CLS_NOCOLOR_ITEM = 'e-nocolor-item';
/**
 * @hidden
 */
export const CLS_TABLE = 'e-rte-table';
/**
 * @hidden
 */
export const CLS_TABLE_BORDER = 'e-rte-table-border';
/**
 * @hidden
 */
export const CLS_RTE_FIXED_TB_EXPAND = 'e-rte-fixed-tb-expand';
/**
 * @hidden
 */
export const CLS_RTE_TB_ENABLED = 'e-rte-toolbar-enabled';
/**
 * @hidden
 */
export const CLS_RTE_RES_WEST = 'e-south-west';
/**
 * @hidden
 */
export const CLS_RTE_SOURCE_CODE_TXTAREA = 'e-rte-srctextarea';
/**
 * @hidden
 */
export const CLS_RTE_IMAGE_UPLOAD_POPUP = 'e-image-upload-popup';
/**
 * @hidden
 */
export const CLS_RTE_VIDEO_UPLOAD_POPUP = 'e-video-upload-popup';
/**
 * @hidden
 */
export const CLS_RTE_AUDIO_UPLOAD_POPUP = 'e-audio-upload-popup';
/**
 * @hidden
 */
export const CLS_AI_COMMANDS_TBAR_BTN = 'e-ai-commands-tbar-btn';
